import {put, takeLatest, call} from 'redux-saga/effects';
import * as promotionService from "../../../../services/promotionService.js";

import {
    CHANGE_PROMOTIONS_VISIBILITY,
    CHANGE_PROMOTIONS_VISIBILITY_SUCCESS,
    CHANGE_PROMOTIONS_VISIBILITY_ERROR,
}
    from "../../../actions/menu/promotions";

function* changePromotionsVisibilitySaga(action) {
    try {
        yield call(promotionService.ChangePromotionsVisibility, action.payload)
        yield put({
            type: CHANGE_PROMOTIONS_VISIBILITY_SUCCESS,
            payload: action.payload.data
        });


    } catch (error) {
        yield put({
            type: CHANGE_PROMOTIONS_VISIBILITY_ERROR,error: error.data
        });
    }
}


export function* changePromotionsVisibilitySagaWatcher() {
    yield takeLatest(CHANGE_PROMOTIONS_VISIBILITY, changePromotionsVisibilitySaga);
}